<template>
  <v-card>
    <v-card-text>
      <v-row>
        <v-col cols="12">
          <v-text-field
            label="Title"
            v-model.trim="doc.title"
            type="text"
            placeholder="Exercise title"
            id="title"
          ></v-text-field>
          <v-text-field
            label="Description"
            v-model.trim="doc.description"
            type="text"
            placeholder="Exercise description"
            id="Description"
          ></v-text-field>
           <v-text-field
            label="Slug"
            v-model.trim="doc.slug"
            type="text"
            placeholder="Slug"
            id="slug"
          ></v-text-field>

           <v-text-field
            label="Icon"
            v-model.trim="doc.icon"
            type="text"
            placeholder="Icon"
            id="icon"
          ></v-text-field>

        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
// @ is an alias to /src
const fb = require("@/firebaseConfig.js");

export default {
  name: "AdminExerciseUpload",
  data() {
    return {
      users: null,
      tiles: null,
    };
  },
  props: {
    doc: Object,
  },
  computed: {
    selectedUsers() {
      if (this.users) {
        return this.users.filter((item) => item.selected === true);
      } else {
        return false;
      }
    },
    selectedTiles() {
      if (this.tiles) {
        return this.tiles.filter((item) => item.selected === true);
      } else {
        return false;
      }
    },
  },
  watch: {
    selectedUsers(val) {
      this.doc.users = val;
    },
    selectedTiles(val) {
      this.doc.tiles = val;
    },
  },
  created() {
    fb.profilesCollection
      .get()
      .then((docs) => {
        let items = [];
        docs.forEach((docs) => {
          let doc = docs.data();
          items.push(doc);
        });
        this.users = items;
      })
      .catch(() => {

      });
    fb.tilesCollection
      .get()
      .then((docs) => {
        let items = [];
        docs.forEach((docs) => {
          let doc = docs.data();
          items.push(doc);
        });
        this.tiles = items;
      })
      .catch(() => {
        
      });
  },
};
</script>
